export function getNonNullProps(obj: any): any {
    const filteredObject: any = {};
    for (const key in obj) {
        if (obj[key] != null && obj[key] != undefined && obj[key] != '' && !Number.isNaN(obj[key]) ) {
            filteredObject[key] = obj[key];
        }
    }
    return filteredObject;
}